import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getCommunicationsTemplates,
  createCommunicationsTemplate,
  getCommunicationsTemplate,
  updateCommunicationsTemplate,
  deleteCommunicationsTemplate
} from "../api";
import { useNotification } from "../../../contexts/NotificationContext";
import { useNavigate } from "react-router-dom";

export const useGetCommunicationsTemplates = (params, options = {}) => {
  return useQuery({
    queryKey: ["communications-templates", params],
    queryFn: () => getCommunicationsTemplates(params),
    staleTime: 1000 * 60 * 5,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    enabled: options.enabled ?? true,
  });
};

export const useGetCommunicationsTemplate = (id) => {
  return useQuery({
    queryKey: ["communications-template", id],
    queryFn: () => getCommunicationsTemplate(id),
    enabled: !!id,
    staleTime: 1000 * 60 * 5,
  });
};

export const useCreateCommunicationsTemplate = () => {
  const queryClient = useQueryClient();
  const { showNotification } = useNotification();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (data) => createCommunicationsTemplate(data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["communications-templates"] });
      showNotification('success', 'Communication template created successfully!');
      navigate('/communication-templates');
    },
    onError: (error) => {
      showNotification('danger', 'Error creating template.');
    },
  });
};

export const useUpdateCommunicationsTemplate = () => {
  const queryClient = useQueryClient();
  const { showNotification } = useNotification();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: ({ id, data }) => updateCommunicationsTemplate(id, data),
    onSuccess: async (_, { id }) => {
      await queryClient.invalidateQueries({ queryKey: ["communications-templates"] });
      await queryClient.invalidateQueries({ queryKey: ["communications-template", id] });
      showNotification('success', 'Communication template updated successfully!');
      // navigate('/communication-templates');
    },
    onError: (error) => {
      showNotification('danger', 'Error updating template.');
    },
  });
};

export const useDeleteCommunicationsTemplate = () => {
  const queryClient = useQueryClient();
  const { showNotification } = useNotification();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (id) => deleteCommunicationsTemplate(id),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["communications-templates"] });
      showNotification('success', 'Communication template deleted successfully!');
      navigate('/communication-templates');
    },
    onError: (error) => {
      showNotification('danger', 'Error deleting template.');
    },
  });
};
